import React from 'react';
import Modal from '../ui/Modal';

/**
 * IMPORTANT: Do NOT render this inside another <Modal>.
 * It spawns its own <Modal> internally which creates an invisible overlay
 * that freezes the parent modal at non-100% browser zoom.
 * For confirmations inside a modal, use an inline panel instead.
 * Reference: src/components/common/ACCApplicationCreateModal.js
 */
const ConfirmDialog = ({
    isOpen,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
}) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onCancel} className="max-w-md w-full" zIndex="z-[100]">
            <div className="relative bg-white rounded-2xl warm-tactile-shadow max-w-md w-full p-6" style={{ paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}>
                <button
                    type="button"
                    onClick={onCancel}
                    aria-label="Close confirmation dialog"
                    className="absolute top-4 right-4 w-10 h-10 rounded-full hover:bg-section-bg flex items-center justify-center text-primary-dark"
                >
                    <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>close</span>
                </button>
                {title && (
                    <h3 className="font-display font-bold text-slate-800 text-lg mb-2">
                        {title}
                    </h3>
                )}
                <p className="text-slate-600 text-sm leading-relaxed mb-6 whitespace-pre-line">
                    {message}
                </p>
                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm font-medium text-slate-600
              bg-slate-100 rounded-xl hover:bg-slate-200 transition-colors"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm font-medium text-white
              bg-forest-700 rounded-xl hover:bg-forest-600 transition-colors"
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmDialog;
